import { render, staticRenderFns } from "./forumLicenses.vue?vue&type=template&id=4997c210"
import script from "./forumLicenses.vue?vue&type=script&lang=js"
export * from "./forumLicenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports